import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApiClient } from '@marageti/z4-lib';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import TravelerCreateAccountFormView from './traveler-create-account-form-view';

const TravelerCreateAccountFormContainer = () => {
  const apiClient = useApiClient();
  const [submissionError, setSubmissionError] = React.useState<ApiError>();
  const [successfullyCreatedTraveler, setSuccessfullyCreatedTraveler] = React.useState<Traveler>();
  const location = useLocation();
  const navigate = useNavigate();

  const handleSubmit = async (data: any) => {
    const {
      givenName, familyName, email, phone, timeZone, tags, referringPartner, countryOfResidence,
    } = data;

    const travelerRequest = {
      givenName,
      familyName,
      email,
      phone,
      timeZone,
      countryOfResidence,
      tags: tags?.map((tag: any) => tag.value) || [],
      referringPartnerId: referringPartner?.id || null,
      userInfo: [{
        roles: [],
      }],
    };

    try {
      setSubmissionError(undefined);
      const createdTraveler = await apiClient.peopleClient.postTraveler(travelerRequest);
      setSuccessfullyCreatedTraveler(createdTraveler);
    } catch (error: any) {
      setSubmissionError(error);
    }
  };

  const handleCancel = () => {
    if (location.key === 'default') {
      navigate('/travelers', { relative: 'path' });
    } else {
      navigate(-1);
    }
  };

  return (
    <TravelerCreateAccountFormView
      handleSubmit={handleSubmit}
      submissionError={submissionError}
      successfullyCreatedTraveler={successfullyCreatedTraveler}
      onCancel={handleCancel}
    />
  );
};

export default TravelerCreateAccountFormContainer;
